const locale = {
	ABSSEARCH_TOOLTIP: 'Fastsearch',
	ABSSEARCH_NORESULTS: 'Nothing found',
	ABSSHORTCUTS_TOOLTIP: 'Manage shortcuts',
	ABSSHORTCUTS_SEARCH_TOOLTIP: 'Search for an app or page',
	LOADINGDOTDOTDOT: "Loading content...",
	CLOSE: "Close",
	NOSELECTION: "No Selection",
	ATTENTION: "Attention",
	USAGEONMOBILEVIEWLIMITED: "This app is not yet fully optimized for use on mobile devices and visual limitations may occur. We ask for your understanding.",
	DONTSHOWAGAIN: "Dont show this again",
};

export default locale;
